import { render, staticRenderFns } from "./BaseInvite.vue?vue&type=template&id=ff9ef252&scoped=true&"
import script from "./BaseInvite.vue?vue&type=script&lang=js&"
export * from "./BaseInvite.vue?vue&type=script&lang=js&"
import style0 from "./BaseInvite.vue?vue&type=style&index=0&id=ff9ef252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9ef252",
  null
  
)

export default component.exports